/**
 * Andre Garen - Tur 14 donusum bayraklari (ag-cro.js).
 * Yalniz <html data-ag-cro="..."> doluyken yuklenir. Bayrak yoksa hicbir sey yapmaz.
 *  - beden   : urun sayfasinda beden on-secilmez; secilmeden Sepete Ekle'ye basilirsa
 *              eklemez, beden satirina kaydirir ve uyari gosterir. (Karar yamasi T11-030 b
 *              uygulanmissa - [data-ag-size-needed] varsa - bu katman devre disi kalir.)
 *  - stok    : "Bu renkte stokta olan bedenler" satirini renk degisince gunceller.
 *  - webview : Instagram/Facebook uygulama ici tarayicisinda sepet cekmecesinde
 *              sepet baglantisini kopyalama yardimi (/cart/<varyant>:<adet>).
 */
(function () {
  'use strict';
  var html = document.documentElement;
  var flags = (' ' + (html.getAttribute('data-ag-cro') || '') + ' ');
  function has(f) { return flags.indexOf(' ' + f + ' ') > -1; }
  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('ag-cro-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }

  function productData() {
    try { return JSON.parse(document.getElementById('ag-product-data').textContent); } catch (e) { return null; }
  }

  /* ---------------- beden: on secim yok ---------------- */
  function initSizeFirst() {
    var row = document.querySelector('.ag-product [data-ag-size-row]');
    if (!row || document.querySelector('[data-ag-size-needed]')) return;
    if (/[?&]variant=/.test(location.search)) return; /* acik varyant baglantisi = bilincli secim */
    var chosen = false;
    html.classList.add('ag-cro-nosize');
    var msg = document.createElement('p');
    msg.className = 'ag-cro-sizemsg'; msg.setAttribute('role', 'alert'); msg.hidden = true;
    msg.textContent = cfg.sizePrompt || 'Önce bedenini seç';
    var wrap = row.closest('.ag-product__sizewrap') || row;
    wrap.insertAdjacentElement('afterend', msg);

    function btns() { return Array.prototype.slice.call(document.querySelectorAll('.ag-product__atc[data-ag-add], [data-ag-stickyatc-btn]')); }
    function relabel() {
      if (chosen) return;
      btns().forEach(function (b) {
        if (b.hasAttribute('data-ag-notify-trigger') || b.getAttribute('aria-disabled') === 'true') return;
        if (!b.hasAttribute('data-ag-cro-label')) b.setAttribute('data-ag-cro-label', b.innerHTML);
        b.textContent = cfg.sizePrompt || 'Önce bedenini seç';
      });
    }
    function restore() {
      btns().forEach(function (b) {
        var l = b.getAttribute('data-ag-cro-label');
        if (l != null && b.textContent === (cfg.sizePrompt || 'Önce bedenini seç')) b.innerHTML = l;
        b.removeAttribute('data-ag-cro-label');
      });
    }
    relabel();
    /* ag-product.js render() etiketleri ag-cro.js'den SONRA yeniden yaziyor (script sirasi) - bir tur sonra ve
       sayfa yuklenince tekrar uygula. */
    setTimeout(relabel, 0);
    window.addEventListener('load', relabel);

    document.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var size = t.closest('.ag-product .ag-size');
      if (size && !chosen) {
        chosen = true; html.classList.remove('ag-cro-nosize'); msg.hidden = true; row.classList.remove('ag-cro-pulse');
        setTimeout(restore, 0); /* ag-product.js render() once calissin */
        return;
      }
      if (!chosen && t.closest('.ag-swatch')) { setTimeout(relabel, 0); return; }
      var add = t.closest('.ag-product__atc[data-ag-add], [data-ag-stickyatc-btn]');
      if (add && !chosen && !add.hasAttribute('data-ag-notify-trigger')) {
        e.preventDefault(); e.stopImmediatePropagation();
        msg.hidden = false;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        row.classList.remove('ag-cro-pulse'); void row.offsetWidth; row.classList.add('ag-cro-pulse');
        var first = row.querySelector('.ag-size:not(.ag-size--out)');
        if (first) first.focus({ preventScroll: true });
      }
    }, true);
  }

  /* ---------------- stok: renk degisince satiri guncelle ---------------- */
  function initStock() {
    var el = document.querySelector('[data-ag-cro-stock]'); if (!el) return;
    var txt = el.querySelector('[data-ag-cro-stock-text]');
    var sIdx = parseInt(el.getAttribute('data-size-idx'), 10), cIdx = parseInt(el.getAttribute('data-color-idx'), 10);
    var data = productData(); if (!data || !txt || isNaN(sIdx) || cIdx < 0) return;
    var order = [];
    data.variants.forEach(function (v) { if (order.indexOf(v.options[sIdx]) < 0) order.push(v.options[sIdx]); });
    function update() {
      var active = document.querySelector('.ag-product .ag-swatch--active');
      var color = active ? active.getAttribute('data-ag-value') : null; if (!color) return;
      var ok = order.filter(function (s) { return data.variants.some(function (v) { return v.available && v.options[sIdx] === s && v.options[cIdx] === color; }); });
      txt.textContent = '';
      if (ok.length) { txt.appendChild(document.createTextNode('Bu renkte stokta olan bedenler: ')); var b = document.createElement('strong'); b.textContent = ok.join(' · '); txt.appendChild(b); }
      else txt.textContent = 'Bu renkte stokta beden kalmadı.';
    }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.ag-product .ag-swatch')) setTimeout(update, 0); });
  }

  /* ---------------- webview: sepet baglantisini kopyala ---------------- */
  function initWebview() {
    var ua = navigator.userAgent || '';
    if (!/Instagram|FBAN|FBAV|FB_IAB|FB4A/.test(ua)) return;
    html.classList.add('ag-cro-iab-on');
    document.querySelectorAll('[data-ag-cro-iab]').forEach(function (n) { n.hidden = false; });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ag-cro-cartlink]'); if (!btn) return;
      e.preventDefault();
      var box = btn.closest('[data-ag-cro-iab]');
      var out = box && box.querySelector('[data-ag-cro-cartlink-msg]');
      var field = box && box.querySelector('[data-ag-cro-cartlink-field]');
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items || !c.items.length) { if (out) out.textContent = 'Sepetin boş.'; return; }
        var link = location.origin + '/cart/' + c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        var done = function () { if (out) out.textContent = 'Bağlantı kopyalandı. Safari ya da Chrome’a yapıştırınca ürünlerin ödeme sayfasında yeniden açılır.'; };
        var manual = function () { if (field) { field.hidden = false; field.value = link; field.focus(); field.select(); } if (out) out.textContent = 'Bağlantıyı seçip kopyala.'; };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, manual); else manual();
      }).catch(function () { if (out) out.textContent = 'Sepet okunamadı, biraz sonra tekrar dene.'; });
    });
  }

  /* ---------------- Tur 15: onerilen beden (Tur 4 C kalip kurali) secili renkte yoksa ----------------
     Oneri: uye olcusu (.ag-size--rec, sunucu) ya da <html data-ag-size> + urunun kalibi (dar: +2). Beden secici
     OTOMATIK SECILMEZ; yalniz stok satirina "bu renkte yok, su renklerde var" notu dusulur. */
  function initRecNote() {
    var note = document.querySelector('[data-ag-cro-recnote]'); if (!note) return;
    var data = productData(); if (!data) return;
    var on = (data.optionNames || []).map(function (n) { return String(n).toLowerCase(); });
    var si = on.indexOf('beden'), ci = on.indexOf('renk'); if (ci < 0) ci = on.indexOf('color'); if (si < 0 || ci < 0) return;
    function rec() {
      var srv = document.querySelector('.ag-product .ag-size--rec'); if (srv) return srv.getAttribute('data-ag-value');
      var s = html.getAttribute('data-ag-size'); if (!s || s === 'none') return null;
      var bar = document.querySelector('.ag-product .ag-sizebar'); var m = bar && bar.className.match(/ag-fit-(\w+)/); if (!m) return null;
      return String(+s + (m[1] === 'dar' ? 2 : 0));
    }
    function update() {
      var r = rec(); note.hidden = true; note.textContent = ''; if (!r) return;
      var active = document.querySelector('.ag-product .ag-swatch--active'); var color = active ? active.getAttribute('data-ag-value') : (data.selected || [])[ci];
      var ok = function (c) { return data.variants.some(function (v) { return v.available && v.options[si] === r && v.options[ci] === c; }); };
      if (!color || ok(color)) return;
      var others = []; data.variants.forEach(function (v) { if (v.available && v.options[si] === r && others.indexOf(v.options[ci]) < 0) others.push(v.options[ci]); });
      if (!others.length) return; /* hic yoksa bar zaten "su an tukendi" diyor */
      note.textContent = 'Sana önerdiğimiz ' + r + ' beden bu renkte yok; ' + others.join(', ') + ' renginde var.';
      note.hidden = false;
    }
    update();
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.ag-product .ag-swatch')) setTimeout(update, 0); });
  }

  function boot() {
    if (has('stok')) initRecNote();
    if (has('beden')) initSizeFirst();
    /* stok satiri artik tum renkleri sunucuda listeliyor; renk degisiminde guncelleme gerekmiyor */
    if (has('webview')) initWebview();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
